import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StyleSheetManager } from 'styled-components';
import { msalInstance } from './authConfig';
const root = ReactDOM.createRoot(document.getElementById('root'));
const nonce = "abc123"; // MUST match CSP

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <StyleSheetManager nonce={nonce}>
        <App />
      </StyleSheetManager>
    </React.StrictMode>
  );
};

const bootstrapAuth = async () => {
  try {
    await msalInstance.initialize();
    const redirectResult = await msalInstance.handleRedirectPromise();
    if (redirectResult?.account) {
      msalInstance.setActiveAccount(redirectResult.account);
    } else {
      const active = msalInstance.getActiveAccount();
      if (!active) {
        const all = msalInstance.getAllAccounts();
        if (all.length > 0) {
          msalInstance.setActiveAccount(all[0]);
        }
      }
    }
  } catch (err) {
    // Keep app usable even if auth bootstrap fails
    console.error('MSAL bootstrap error:', err);
  } finally {
    renderApp();
  }
};

bootstrapAuth();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
